import React, { useState } from "react";
import { searchCategoryName } from "./categoryNameData";
import "./categoryName.css";

const tidy = (text) => text.trim().split(/\s+/).join(" ");

function Choices({ result, onUse, onAdd, busy }) {
  const { searched } = result;
  if (result.error) return <p className="cns__note cns__note--error">{result.error}</p>;
  if (result.kind === "same") {
    const { umbrella, existing } = result;
    return (
      <div className="cns__result">
        <p className="cns__note">
          {umbrella.name} already exists. Use it, so customers find every {umbrella.name} in one place.
        </p>
        <button type="button" className="btn btn-primary" disabled={busy} onClick={() => onUse(umbrella, existing)}>
          Use {umbrella.name}
        </button>
      </div>
    );
  }
  if (result.kind === "close") {
    return (
      <div className="cns__result">
        <p className="cns__note">{searched} looks like a category we already have:</p>
        <div className="cns__buttons">
          {result.close.map((umbrella) => (
            <button key={umbrella.id} type="button" className="btn btn-primary" disabled={busy} onClick={() => onUse(umbrella, null)}>
              Use {umbrella.name}
            </button>
          ))}
          <button type="button" className="btn btn-light" disabled={busy} onClick={() => onAdd({ name: searched, confirmNew: true })}>
            No, add {searched} as new
          </button>
        </div>
      </div>
    );
  }
  return (
    <div className="cns__result">
      <p className="cns__note">Nothing like {searched} yet.</p>
      <button type="button" className="btn btn-primary" disabled={busy} onClick={() => onAdd({ name: searched, confirmNew: false })}>
        Add {searched} as a new category
      </button>
    </div>
  );
}

export default function CategoryNameSearch({ onUse, onAdd, busy = false }) {
  const [name, setName] = useState("");
  const [result, setResult] = useState(null);
  const [searching, setSearching] = useState(false);
  const typed = tidy(name);

  const search = async () => {
    if (!typed || searching) return;
    setSearching(true);
    const reply = await searchCategoryName(typed);
    setResult({ ...reply, searched: typed });
    setSearching(false);
  };

  return (
    <div className="cns">
      <label className="cns__label" htmlFor="cns-name">
        Menu name
      </label>
      <div className="cns__row">
        <input
          id="cns-name"
          className="form-control"
          value={name}
          onChange={(event) => {
            setName(event.target.value);
            setResult(null);
          }}
          onKeyDown={(event) => {
            if (event.key === "Enter") {
              event.preventDefault();
              search();
            }
          }}
        />
        <button type="button" className="btn btn-primary" disabled={!typed || searching} onClick={search}>
          Search
        </button>
      </div>
      {result && <Choices result={result} onUse={onUse} onAdd={onAdd} busy={busy} />}
    </div>
  );
}
